import { render, staticRenderFns } from "./ExportSettings.vue?vue&type=template&id=2f229fce&"
import script from "./ExportSettings.vue?vue&type=script&lang=js&"
export * from "./ExportSettings.vue?vue&type=script&lang=js&"
import style0 from "./ExportSettings.vue?vue&type=style&index=0&id=2f229fce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports